import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import nl from './nl.json';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: 'nl',
    keySeparator: '.',
    debug: true,
    resources: {
        en: en,
        nl: nl
    },
    interpolation: {
        skipOnVariables: false
    }
});
export default i18n;
